import { customerSettingsFragment, orgAddressFragment } from 'apollo/fragments';
import { gql } from 'graphql.macro';

export const getOrganizationsTemplate = gql`
    query organizations($type: String, $local: Boolean, $isWhiteLabeled: Boolean) {
        organizations(type: $type, local: $local, isWhiteLabeled: $isWhiteLabeled) {
            _id
            name
        }
    }
`;

export const getLabTemplate = gql`
    query lab($id: MongoDbObjectId!) {
        lab(id: $id) {
            _id
            name
            transportSettings {
                denthubTransport {
                    isEnabled
                    externalId
                }
                nShiftTransport {
                    isEnabled
                    partners {
                        id
                        description
                        services {
                            id
                            description
                            paymentMethodType
                            addons
                        }
                    }
                    waybillPrintFormat
                    waybillPackageSizes {
                        _id
                        name
                        width
                        height
                        length
                    }
                }
            }
            customerSettings {
                ...customerSettingsFields
            }
        }
    }
    ${customerSettingsFragment}
`;

export const organizationLookupTemplate = gql`
    query organizationLookup(
        $countryCode: String!
        $organizationNumber: String!
        $checkWhitelabel: Boolean!
        $type: String
        $existingOnly: Boolean
    ) {
        organizationLookup(
            countryCode: $countryCode
            organizationNumber: $organizationNumber
            checkWhitelabel: $checkWhitelabel
            type: $type
            existingOnly: $existingOnly
        ) {
            organizationDbId
            existsInDb
            hitHorizonsId
            name
            type
            isAlreadyConnected
            organizationNumber
            address {
                ...orgAddressFields
            }
            site
            vatNumber
            costCenter
            isWhiteLabeled
        }
    }
    ${orgAddressFragment}
`;

export const hithorizonsLookupTemplate = gql`
    query hithorizonsLookup($organizationId: MongoDbObjectId!) {
        hithorizonsLookup(organizationId: $organizationId) {
            hitHorizonsId
            name
            type
            organizationNumber
            address {
                ...orgAddressFields
            }
            site
            vatNumber
        }
    }
    ${orgAddressFragment}
`;

export const salesforceUsersTemplate = gql`
    query salesforceUsers($organizationId: MongoDbObjectId) {
        salesforceUsers(organizationId: $organizationId) {
            id
            name
            email
        }
    }
`;

export const getDefaultCustomerSettingsTemplate = gql`
    query getDefaultCustomerSettings {
        getDefaultCustomerSettings {
            category
            name
            type
            description
            defaultValue
            values
        }
    }
`;

export const getCustomerSettingsByIdTemplate = gql`
    query GetCustomerSettingsById($organizationId: MongoDbObjectId!) {
        getCustomerSettingsById(organizationId: $organizationId) {
            _id
            name
            type
            customerSettings {
                _id
                name
                value
            }
        }
    }
`;
